module.exports = __webpack_public_path__ + "static/img/Tarjeta-Smartphone.5277675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Tarjeta-Smartphone.png
// module id = 494
// module chunks = 2 12